import React from 'react';
import dayjs from 'dayjs';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';


const VaultInvestmentView = ({ investmentView: { accountNumber, accountName, statements }, onDownloadClick }) => (
  <div className="vault_investments-list_item">
    <h3>{accountNumber} {accountName}</h3>
    {
      !!statements &&
      (
        <div>
          {
            statements.map((statement, index) => {
              return statement.isDownloadAvailable ?
                (<Button key={index} type="link" icon={<DownloadOutlined />} onClick={() => { onDownloadClick(statement.id) }}>
                  {dayjs(statement.statementDate).format("MM/DD/YYYY")}
                </Button>) :
                null;
              })
          }
        </div>
      )
    }
  </div>
);

export default VaultInvestmentView;
